import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconStatusbarMouseRight = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	fillRule: "evenodd",
	strokeMiterlimit: 1.5,
	clipRule: "evenodd",
	viewBox: "0 0 42 59",
	width: "1em",
	height: "1em",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 4.17,
		d: "M39.583 29.159v11.883A15.174 15.174 0 0 1 24.376 56.25h-7.085A15.175 15.175 0 0 1 2.083 41.042V17.291A15.175 15.175 0 0 1 17.291 2.083h3.542"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "nonzero",
		d: "M25 0c9.261.352 16.667 7.957 16.667 17.281V25H25z"
	})]
});
export default SvgIconStatusbarMouseRight;
